import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'utils/window';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import './Tooltip.css';
import { TooltipContentWrapper, TooltipContentArrow } from './Tooltip.styled';

const TooltipElement = ({ ...props }) => {
  let newProps = props;
  newProps.html = (
    <TooltipContentWrapper>
      {props.html}
      {props.arrow && <TooltipContentArrow />}
    </TooltipContentWrapper>
  );
  newProps.arrow = false;
  return <Tooltip {...newProps} />;
};

TooltipElement.propTypes = {
  html: PropTypes.node,
  arrow: PropTypes.bool
};

TooltipElement.defaultProps = {
  popperOptions: {
    modifiers: {
      preventOverflow: {
        boundariesElement: 'viewport'
      }
    },
    positionFixed: isMobile
  },
  useContext: true,
  stickyDuration: 0,
  theme: 'light',
  animateFill: false,
  arrow: false
};

export default TooltipElement;
